import BaseService from "@/boot/BaseService";
class EmpresaService extends BaseService {
  constructor() {
    super(null, "/empresa");
  }
  async index() {
    return await this.get("/");
  }
}

export default new EmpresaService();
